const DATE_TIME_MOMENT_FORMAT = {
    date: 'DD-MMM-YYYY',
    monthyear: 'MMM-YYYY',
    time: 'hh:mm a',
    full: 'DD-MMM-YYYY hh:mm a',
    calendar_mobile: 'ddd D',
    in_date: 'MMMM DD YYYY',
    parseInput: 'YYYY-MM-DD HH:mm:ss',
    parseInputDateOnly: 'YYYY-MM-DD'
};

const EMAIL_VALIDATOR_REGEXP = "^(([^<>()[\\]\\\\.,;:\\s@\"]+(\\.[^<>()[\\]\\\\.,;:\\s@\"]+)*)|(\".+\"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$";

const URL_VALIDATOR_REGEXP = '((([A-Za-z]{3,9}:(?:\\/\\/)?)(?:[\\-;:&=\\+\\$,\\w]+@)?[A-Za-z0-9\\.\\-]+|(?:www\\.|[\\-;:&=\\+\\$,\\w]+@)[A-Za-z0-9\\.\\-]+)((?:\\/[\\+~%\\/\\.\\w\\-_]*)?\\??(?:[\\-\\+=&;%@\\.\\w_]*)#?(?:[\\.\\!\\/\\\\\\w]*))?)';

const STATES = [
    'AL',
    'AK',
    'AZ',
    'AR',
    'CA',
    'CO',
    'CT',
    'DE',
    'DC',
    'FL',
    'GA',
    'HI',
    'ID',
    'IL',
    'IN',
    'IA',
    'KS',
    'KY',
    'LA',
    'ME',
    'MD',
    'MA',
    'MI',
    'MN',
    'MS',
    'MO',
    'MT',
    'NE',
    'NV',
    'NH',
    'NJ',
    'NM',
    'NY',
    'NC',
    'ND',
    'OH',
    'OK',
    'OR',
    'PA',
    'RI',
    'SC',
    'SD',
    'TN',
    'TX',
    'UT',
    'VT',
    'VA',
    'WA',
    'WV',
    'WI',
    'WY'
];

const BILL_CADENCES = [
    { value: 'Ad-Hoc', label: 'Ad-Hoc' },
    { value: 'Monthly', label: 'Monthly' },
    { value: 'Quarterly', label: 'Quarterly' },
    { value: 'Annually', label: 'Annually' },
];

const MSA_STATUS = [
    { value: 'Awaiting Signature', label: 'Awaiting Signature' },
    { value: 'Completed', label: 'Completed' },
    { value: 'Executed', label: 'Executed' },
    { value: 'Expired', label: 'Expired' }
];

const PREPARED_PAYMENT_PAYMENT_TYPES = [{
        label: 'EFT',
        value: 'EFT',
        icon: 'fa-duotone fa-nfc-pen',
        description: 'Via Realtor Ecommerce, you will need to make the payment and provide the EC Control number as part of this process.'
    },
    {
        label: 'Check',
        value: 'Check',
        icon: 'fa-duotone fa-money-check',
        description: `We'll provide a reference number to include when sending us your check.`
    },
    {
        label: 'Wire/Bank Transfer',
        value: 'Wire',
        icon: 'fa-duotone fa-network-wired',
        description: `We'll provide a reference number to add to your Wire Payment.`
    },
    {
        label: 'Bag of Checks',
        value: 'Checks',
        icon: 'fa-duotone fa-money-check-dollar-pen',
        description: `We’ll provide a reference number to include when sending us your bag of checks.`
    }
];

/**
 * Generated bundle index. Do not edit.
 */

export { BILL_CADENCES, DATE_TIME_MOMENT_FORMAT, EMAIL_VALIDATOR_REGEXP, MSA_STATUS, PREPARED_PAYMENT_PAYMENT_TYPES, STATES, URL_VALIDATOR_REGEXP };
